import { render, staticRenderFns } from "./CandidateRating.vue?vue&type=template&id=656d16c8&"
import script from "./CandidateRating.vue?vue&type=script&lang=js&"
export * from "./CandidateRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports